import React from 'react';

type AdminTab = 'portrait' | 'paysages' | 'voiture' | 'tournages';

interface SidebarProps {
  activeTab: AdminTab;
  setActiveTab: (tab: AdminTab) => void;
  logout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab, logout }) => {
  const tabs: { id: AdminTab; label: string; icon: string }[] = [
    { id: 'portrait', label: 'Portraits', icon: '📷' },
    { id: 'paysages', label: 'Paysages', icon: '🏞️' },
    { id: 'voiture', label: 'Voiture', icon: '🚗' },
    { id: 'tournages', label: 'Tournages', icon: '🎬' }
  ];

  return (
    <div className="w-64 bg-gray-800 shadow-md border-r border-gray-700">
      <div className="p-6 border-b border-gray-700">
        <h2 className="text-xl font-serif text-white">𝓨𝓸𝓱𝓪𝓷𝓥𝓲𝓼𝓲𝓸𝓷</h2>
        <p className="text-sm text-gray-400">Panneau d'administration</p>
      </div>
      
      <nav className="mt-4">
        <div className="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">
          Gestion des médias
        </div>
        
        <ul>
          {tabs.map((tab) => (
            <li key={tab.id}>
              <button
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center px-4 py-3 text-left ${
                  activeTab === tab.id
                    ? 'bg-gray-700 text-white border-l-4 border-gray-300'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                <span className="mr-3">{tab.icon}</span>
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
        
        <div className="px-4 py-2 mt-6 text-xs font-semibold text-gray-400 uppercase tracking-wider">
          Compte
        </div>
        
        <button
          onClick={logout}
          className="w-full flex items-center px-4 py-3 text-left text-gray-300 hover:bg-gray-700 hover:text-white"
        >
          <span className="mr-3">🚪</span>
          Déconnexion
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
